import React from 'react';

const PermissionMissing = () => {
  return (
    <div
      style={{
        margin: 'auto',
        justifyContent: 'center',
        justifyItems: 'center',
        padding: '10px',
        width: '50%',
        minWidth: '500px',
        textAlign: 'center',
        display: 'flex',
        minHeight: '90vh',
        flexDirection: 'column',
      }}
    >
      <h3>Thank you for your interest in CareMappr</h3>
      <br></br>
      <div>
        <p>
          You are missing permissions to access this page. Please contact your
          supervisor or the CareMappr support team for updates.
        </p>
      </div>
    </div>
  );
};

export default PermissionMissing;
